var $701d0854e4f18979$exports = {};
$701d0854e4f18979$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obrigat\xf3rio)`
};


export {$701d0854e4f18979$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
